module.exports = __webpack_public_path__ + "img/ຊຸມຊົນ-711x800.9bbcf8ea.jpg";